export const firestoreKeys = Object.freeze({
  USERS: 'users',
  BOOKINGS: 'bookings',
  REVIEWS: 'reviews',
  QUOTES: 'quotes',
  FAVOURITES: 'favourites',
  MAIL: 'mail',
  CATEGORIES: 'categories',
  CUSTOM_FIELDS: 'custom-fields',
  LISTINGS: 'listings',
  JOBS: 'jobs',
  CONVERSATIONS: 'conversations',
  MESSAGES: 'messages',
  CALENDAR: 'calendar',
  SUPPORT_TICKETS: 'supportTickets',
});

export const toastSeverity = Object.freeze({
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
});

export const firebaseErrorCodes = Object.freeze({
  EMAIL_IN_USER: 'auth/email-already-in-use',
});

export const listingStatuses = Object.freeze({
  UNPUBLISHED: 'Unpublished',
  PUBLISHED: 'Published',
  ACTIVE: 'Active',
  DISABLED: 'Disabled',
  PAUSED: 'Paused',
});

// Maximum number of listings allowed for each subscription plan
export const maxListingsPerPlan = Object.freeze({
  STANDARD: 1,
  STANDARD_PLUS: 3,
  PREMIUM: 10,
  // Map plan IDs to their constants for easier lookup
  standard: 1,
  'standard-plus': 3,
  premium: 10,
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const daysOfWeek = Object.freeze(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);

export const QUOTES_LISTING_COLUMNS = [
  { id: 'customer', label: 'Customer', align: 'left' },
  { id: 'listing', label: 'Service Listing', align: 'left' },
  { id: 'amount', label: 'Quoted Price', align: 'left' },
  { id: 'date', label: 'Date & Time of Service', align: 'left' },
  { id: 'status', label: 'Quote Status', align: 'left' },
];

export const CUSTOMER_BOOKINGS_COLUMNS = [
  { id: 'id', label: 'Booking Id', align: 'left' },
  { id: 'listing', label: 'Service Name', align: 'left' },
  { id: 'provider', label: 'Service Provider', align: 'left' },
  { id: 'dateOrdered', label: 'Date Ordered', align: 'left' },
  { id: 'dateReceived', label: 'Quote Received', align: 'left' },
  { id: 'orderStatus', label: 'Order Status', align: 'left' },
  { id: 'jobStatus', label: 'Job Status', align: 'left' },
  { id: 'paymentStatus', label: 'Payment Status', align: 'left' },
];

export const PROVIDER_BOOKINGS_COLUMNS = [
  { id: 'id', label: 'Booking Id', align: 'left' },
  { id: 'listing', label: 'Service Name', align: 'left' },
  { id: 'customer', label: 'Customer', align: 'left' },
  { id: 'dateOrdered', label: 'Date Ordered', align: 'left' },
  { id: 'dateSent', label: 'Quote Sent Date', align: 'left' },
  { id: 'orderStatus', label: 'Order Confirmation', align: 'left' },
  { id: 'jobStatus', label: 'Job Status', align: 'left' },
];

export const orderStatuses = Object.freeze({
  PENDING: 'Pending',
  CONFIRMED: 'Confirmed',
  CANCELLED: 'Cancelled',
  RESCHEDULE_REQUESTED: 'Reschedule Requested',
});

export const jobStatuses = Object.freeze({
  PENDING: 'Pending Completion',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  COMPLETED_REVIEW_OUTSTANDING: 'Completed, Review Outstanding',
  AWAITING_CUSTOMER: 'Awaiting Customer Confirmation',
  AWAITING_CUSTOMER_REVIEW: 'Awaiting Customer Review',
});

export const paymentStatuses = Object.freeze({
  QUOTE_RECEIVED: 'Quote Received',
  DEPOSIT_PAID: 'Deposit Paid',
  FULLY_PAID: 'Fully Paid',
  CANCELLED: 'Cancelled',
});

export const STATUS_OPTIONS = Object.freeze(['Paid', 'Pending', 'Cancelled', 'Expired', 'Rejected']);

export const quoteStatuses = Object.freeze({
  PAID: 'Paid',
  PENDING: 'Pending',
  UNPAID: 'Unpaid',
  CANCELLED: 'Cancelled',
  ACCEPTED: 'Accepted',
  EXPIRED: 'Expired',
  REJECTED: 'Rejected',
});

export const messageTypes = Object.freeze({
  QUOTE: 'Quote',
  RESCHEDULE: 'Reschedule',
  NOTIFICATION: 'Notification',
});

export const maxLocationRadius = 100;

export const userTypes = Object.freeze({
  CUSTOMER: 'Customer',
  PROVIDER: 'Provider',
});

export const supportTicketStatuses = Object.freeze({
  URGENT: 'Urgent',
  ACTIVE: 'Active',
  RESOLVED: 'Resolved',
});

export const ratingOptions = Object.freeze([1, 2, 3, 4, 5]);

export const listingActionTypes = Object.freeze({
  PREVIEW: 'preview',
  SAVE: 'save',
  PUBLISH: 'publish',
});
